import styled from 'styled-components';

import colors from '@theme/colors';

export const FieldCheckbox = styled.div`
  display: flex;
  margin: 2.4rem 0;
`;

export const FieldCheckboxInput = styled.input`
  background-color: transparent;
  width: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;
  appearance: none;
  font-size: 1.1rem;
  letter-spacing: 0.5px;
  box-shadow: none;
  border-radius: 0px;
  color: ${colors['charcoal']};
  border: ${({ dark }) =>
    dark ? `solid 1px ${colors['egg-shell']}` : `solid 1px ${colors['ash']}`};

  &:focus {
    outline: none;
  }
  &:checked {
    background-color: ${({ dark }) =>
      dark ? colors['egg-shell'] : colors['white']};
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTkuODk0IDEuMjVMOC43ODEuMTAzQS4zMzIuMzMyIDAgMCAwIDguNTQyIDBhLjMzMi4zMzIgMCAwIDAtLjIzOS4xMDNMMy42NjQgNC44ODIgMS42OSAyLjg0OWEuMzMxLjMzMSAwIDAgMC0uNDc4IDBMLjEgMy45OTdhLjM1Mi4zNTIgMCAwIDAgMCAuNDkybDMuMzI2IDMuNDI3YS4zMzIuMzMyIDAgMCAwIC40NzcgMGw1Ljk5Mi02LjE3NGEuMzU3LjM1NyAwIDAgMCAwLS40OTIiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNyA4KSI+CiAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPC9tYXNrPgogICAgICAgIDx1c2UgZmlsbD0iIzAwMCIgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICA8ZyBmaWxsPSIjNDA0MjNGIiBtYXNrPSJ1cmwoI2IpIj4KICAgICAgICAgICAgPHBhdGggZD0iTS03LThoMjR2MjRILTd6Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K');
    background-size: 1.5rem 1.5rem;
    background-position: center;
  }

  &.ltr {
    margin-right: 1em;
  }
  &.rtl {
    margin-left: 1em;
  }
`;

export const FieldCheckboxLabel = styled.div`
  color: ${({ dark }) => (dark ? colors['beige'] : colors['charcoal'])};
  font-size: 0.9rem;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  padding: 0;
`;
